import React from 'react'
import GenericTable from '../general/generic-table'
import { utilService } from '../../services/util-service'

interface CompanyTableProps {
    data: any[]
    onEditClick?: (company: any) => void
}

const createMapping = (title: string, location: string[], type: string, trueText?: string, falseText?: string) => ({
    title, location, type, trueText, falseText
})

const mapping = [
    createMapping('ID', ['id'], 'int'),
    createMapping('Company Name', ['name'], 'string'),
    createMapping('Abbreviation', ['abbreviation'], 'string'),
    createMapping('Logo URL', ['logoUrl'], 'string'),
    createMapping('Is Silo', ['isSilo'], 'boolean', 'Yes', 'No'),
    createMapping('Created At', ['createdAt'], 'date'),
]

export const CompanyTable: React.FC<CompanyTableProps> = ({ data, onEditClick }) => {
    const tableData: any[][] = data.map((record: any) =>
        mapping.map((m) => ({
            title: m.title,
            value: utilService.getCellValue(record, m),
            type: m.type,
        }))
    )

    const handleEditClick = onEditClick ? (rowData: any[]) => {
        const idCell = rowData.find((cell: any) => cell.title === 'ID')
        const companyId = Number(idCell?.value)
        const rawItem = data.find((item: any) => Number(item.id) === companyId)
        if (rawItem) onEditClick(rawItem)
    } : undefined

    return (
        <GenericTable
            data={tableData}
            recordName="Companies"
            hiddenByDefault={['ID']}
            onEditClick={handleEditClick}
            editColumn="Company Name"
            filterableColumns={['Company Name', 'Abbreviation', 'Is Silo']}
        />
    )
}

export default CompanyTable
